module API.Autofill where

import Common

import API.FormBase (FormID)
import API.SelEmployer (ContactID, EmployerID, PositionID, PosConEmployer)
import API.Signature (SigDefaults)
import API.Types (StudentID, TeacherID, CourseID)
import Data.Argonaut (class EncodeJson)
import GraphQL.Query (Query, buildQuery, nameQuery)
import GraphQL.Type (class HasQType, NamedType, QType(..), namedType)
import Record as Rec
import Type.Prelude (Proxy(..))


type AutofillArgs =
    { form :: FormID
    , student_id :: StudentID
    , teacher_id :: Maybe TeacherID
    , employer_id :: Maybe EmployerID
    , position_id :: Maybe PositionID
    , contact_id :: Maybe ContactID
    , courses :: Array CourseAutofillEntry
    , types :: Array AutofillType
    }

type AutofillResult =
    { data :: Json
    , employer :: Maybe PosConEmployer
    , signature_fields :: Array SigDefaults
    }

data AutofillType = CoursesAF | StudentAF | TeacherAF | EmployerAF | ContactAF | PositionAF | NowAF

autofillTypeStr :: AutofillType -> String
autofillTypeStr CoursesAF = "COURSES"
autofillTypeStr StudentAF = "STUDENT"
autofillTypeStr TeacherAF = "TEACHER"
autofillTypeStr EmployerAF = "EMPLOYER"
autofillTypeStr ContactAF = "CONTACT"
autofillTypeStr PositionAF = "POSITION"
autofillTypeStr NowAF = "NOW"

derive instance aftEq :: Eq AutofillType
instance aftEnc :: EncodeJson AutofillType where
    encodeJson = encodeJson <<< autofillTypeStr
instance aftQT :: HasQType AutofillType where
    gqlType _ = QType "AutofillType"

type CourseAutofillEntry = { index :: Int, id :: CourseID }

initAutofillArgs :: FormID -> StudentID -> AutofillArgs
initAutofillArgs form student_id =
    { form, student_id
    , teacher_id: Nothing
    , employer_id: Nothing
    , position_id: Nothing
    , contact_id: Nothing
    , courses: []
    , types: []
    }

autofillData :: AutofillArgs -> Query AutofillResult
autofillData args = nameQuery "AutofillForm" $ buildQuery "autofillData" $ renameArgs args
  where
    renameArgs = Rec.modify (Proxy :: Proxy "courses") (map fixCourse)
        <<< Rec.rename (Proxy :: Proxy "form") (Proxy :: Proxy "type_id")
        <<< Rec.rename (Proxy :: Proxy "types") (Proxy :: Proxy "allowed_types")
    fixCourse :: CourseAutofillEntry -> NamedType "AutofillIDInput" _
    fixCourse = namedType
